import { createContext } from 'react';
import { AppAbility } from '@/services/permission';

export const PermissionContext = createContext<AppAbility | undefined>(undefined);
